import React, { useState } from 'react';
import useWindowSize from './useWindowSize';

export default function Design({ options, onDesignSelected, selectedDesign }) {
    const isMobile = useWindowSize().isMobile;

    const designContainerStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '25px',
        padding: isMobile ? '1.5rem 1rem' : '2.5rem',
        width: '100%',
        boxSizing: 'border-box',
        color: '#fff',
        backgroundColor: 'rgba(18, 18, 18, 0.55)',
        backdropFilter: 'blur(16px) saturate(120%)',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        WebkitMaskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
        maskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
    }

    const listContainerStyle = {
        flex: isMobile ? 'none' : '3',
        width: '100%',
    }

    const designListStyle = {
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        gap: '20px',
        listStyleType: 'none',
        padding: '0',
        margin: '0',
        width: '100%',
    }

    const designListStyleLi = (isActive) => ({
        fontFamily: '"Chivo", sans-serif',
        fontWeight: 'bold',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        padding: '15px',
        backgroundColor: isActive ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.05)',
        border: isActive ? '1px solid rgba(255, 255, 255, 0.3)' : '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        cursor: 'pointer',
        transition: 'transform 0.2s, background-color 0.2s',
        boxSizing: 'border-box',
        textAlign: 'center',
        color: '#fff',
    })

    const imageStyle = {
        height: '110px',
        width: '110px',
        objectFit: 'contain',
        borderRadius: '8px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
    }

    const infoBContainer = {
        flex: isMobile ? 'none' : '1.8',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
    }

    const infoBStyle = {
        width: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        padding: '20px',
        borderRadius: '12px',
        color: 'rgb(0, 0, 0)',
        border: '2px solid rgb(242, 66, 12)',
        boxSizing: 'border-box',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '160px',
    }

    const getImageMetaData = (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => {
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            };
        });
    };

    const [currentMeta, setCurrentMeta] = useState({ width: 0, height: 0 });

    const doImageClick = async (option) => {
        onDesignSelected(option.value);
        const meta = await getImageMetaData(option.imageUrl);
        setCurrentMeta(meta);
    };

    return (
        <div className="Design" style={designContainerStyle}>
            <div style={listContainerStyle}>
                <ul className="designList" style={designListStyle}>
                    {options.map(option => (
                        <li 
                            style={designListStyleLi(selectedDesign === option.value)} 
                            key={option.value} 
                            onClick={() => doImageClick(option)}
                        >
                            <span style={{ fontSize: '1.1em', fontVariant: 'small-caps' }}>{option.value}</span>
                            <img src={option.imageUrl} style={imageStyle} alt={option.value} />
                        </li>
                    ))}
                </ul>
            </div>
            
            <div style={infoBContainer}>
                <div className="infoB" style={infoBStyle}>
                    <h4 style={{ margin: '0 0 5px 0', fontSize: '1.2em' }}>Image Specifications</h4>
                    <p style={{ color: 'black', margin: '0', fontSize: '1.1em', fontWeight: 'bold' }}>
                        Resolution: {currentMeta.width} x {currentMeta.height}px
                    </p>
                    {currentMeta.width > 0 && currentMeta.height > 0 && (
                        currentMeta.width === 4500 && currentMeta.height === 5400 ? (
                            <span style={{ color: 'green', fontWeight: 'bold', fontSize: '1.1em' }}>✓ Amazon Ready</span>
                        ) : (
                            <span style={{ color: 'red', fontWeight: 'bold', fontSize: '1.1em' }}>✗ Invalid Dimensions</span>
                        )
                    )}
                </div>
            </div>
        </div>
    );
}
